<template>
	<div>
		<Header :title="isEdit ? '编辑购票模式配置' : '新增购票模式配置'" @back="onBack(false)"></Header>
		<a-spin :spinning="loading">
			<a-form style="margin-top: 20px;" ref="form" name="form" :model="modelRef" scrollToFirstError
				:label-col="{ span: 4 }" :wrapper-col="{ span: 14 }" @finish="onSubmit">

				<a-form-item class="ui-form__item" name="organizationId" label="影院组织"
					:rules="[{ required: true, message: '必选项不允许为空' }]">
					<a-select :disabled="isSee || isEdit" placeholder="请选择" v-model:value="modelRef.organizationId"
						@change="(id) => getAllCinemaList(id)">
						<a-select-option v-for="item in organizationList" :value="item.id" :key="item.id">
							{{ item.name }}</a-select-option>
					</a-select>
				</a-form-item>

				<a-form-item class="ui-form__item" name="cinemaId" label="所属影院"
					:rules="[{ required: true, message: '必选项不允许为空' }]">
					<a-select :disabled="isSee || isEdit" placeholder="请选择" v-model:value="modelRef.cinemaId"
						@change="onCinemaChange">
						<a-select-option v-for="item in cinemaList" :value="item.id" :key="item.id">
							{{ item.name }}</a-select-option>
					</a-select>
				</a-form-item>

				<!-- <a-form-item label="标题" name="name" :rules="[{ required: true, message: '必填项不允许为空' }]">
					<a-input v-model:value="modelRef.name" placeholder="请输入" />
				</a-form-item> -->

				<a-form-item label="配置类型" name="type" :rules="[{required: true, message: '必选项不允许为空'}]">
					<a-radio-group :disabled="isSee || isEdit" v-model:value="modelRef.type" button-style="solid" @change="modelRef.payTypes = []">
						<a-radio-button :value="1">按影片配置</a-radio-button>
						<a-radio-button :value="2">按支付方式配置</a-radio-button>
						<a-radio-button :value="3">按用户注册时间</a-radio-button>
					</a-radio-group>
				</a-form-item>

				<a-form-item label="购票模式" name="buyTicketMode" :rules="[{required: true, message: '必选项不允许为空'}]">
					<a-radio-group :disabled="isSee" v-model:value="modelRef.buyTicketMode" button-style="solid">
						<a-radio-button :value="1">票务系统出票</a-radio-button>
						<a-radio-button :value="2">云端系统出票</a-radio-button>
						<a-radio-button :value="3">POS出票</a-radio-button>
					</a-radio-group>
				</a-form-item>

				<a-form-item label="影片" name="standardCode" :rules="[{ required: true, message: '必选项不允许为空' }]"
					v-if="modelRef.type == 1">
					<a-form-item-rest>
						<div v-if="modelRef.cinemaId">
							<movie :id="modelRef.cinemaId" :disabled="isSee || isEdit"
								v-model:value="modelRef.standardCode" :selectItem="movieList"
								@change="(dataList) => { movieList = dataList; }"></movie>
						</div>
						<a-button v-else disabled>请选择所属影院</a-button>
					</a-form-item-rest>
					<div v-if="movieList.length" style="margin: 10px 0;">
						<a-table rowKey="standardCode" :columns="movieColumns" :dataSource="movieList" size="small"
							:pagination="false">
							<template #bodyCell="{ column, record, index }">
								<template v-if="column.key === 'action' && !isSee">
									<a-button :disabled="isSee" type="link"
										@click="onDeleteMovie(record, index)">删除</a-button>
								</template>
							</template>
						</a-table>
					</div>
				</a-form-item>

				<a-form-item label="支付类型" name="payTypes" :rules="[{required: true, message: '必选项不允许为空'}]"
					v-if="modelRef.type == 2">
					<a-select v-model:value="modelRef.payTypes" size="middle" mode="tags" @change="onPayTypeChange">
						<a-select-option :value="1">微信支付</a-select-option>
						<a-select-option :value="2">年卡</a-select-option>
						<a-select-option :value="3">次卡</a-select-option>
						<a-select-option :value="4">兑换券</a-select-option>
						<a-select-option :value="5">线上会员卡</a-select-option>
						<a-select-option :value="6">抖音券</a-select-option>
						<a-select-option :value="7">影城会员卡</a-select-option>
						<a-select-option :value="8">第三方线下支付</a-select-option>
						<a-select-option :value="9">现金支付</a-select-option>
					</a-select>
				</a-form-item>

				<div v-if="modelRef.payTypes.includes(4)">
					<a-form-item label="兑换券批次" name="validType" :rules="[{required: true, message: '必填项不允许为空'}]">
						<a-form-item-rest>
							<couponRecord v-model:value="modelRef.couponBatchNos" :id="modelRef.cinemaId" type="checkbox" :couponType="1" :selectItem="exchangeList" :disabled="isSee" from="all" @change="(data) => onCouponChange(1, data)"></couponRecord>
						</a-form-item-rest>
						<div v-show="modelRef.couponBatchNos.length">
							<a-table rowKey="id" :columns="exchangeColumns" :dataSource="exchangeList" :pagination="false" :scroll="{ x: 1200 }">
								<template #bodyCell="{ column, record }">
									<template v-if="column.key === 'createdTime'">
										{{ transDateTime(record.createTime) }}
									</template>

									<template v-if="column.key === 'time'">
										<div v-if="record.validPeriodType == 7">
											领取后{{ record.period }}天内有效
										</div>
										<div v-else>
											{{ transDateTime(record.receiveStartTime, 1) }} - {{ transDateTime(record.receiveEndTime, 1) }}
										</div>
									</template>

									<template v-if="column.key === 'redeemedCount'">
										{{ record.importCount - record.redeemedCount }}
									</template>

									<template v-if="column.key === 'isHoliday'">
										<div v-if="record.isHoliday">通兑</div>
										<div v-else>非通兑</div>
									</template>

									<template v-if="column.key === 'action'">
										<a-button :disabled="isSee" type="line" @click="onDelCoupon(1, index)">删除</a-button>
									</template>
								</template>
							</a-table>
						</div>
					</a-form-item>
				</div>

				<div v-if="modelRef.payTypes.includes(5)">
					<a-form-item label="线上会员卡等级" name="validType" :rules="[{required: true, message: '必填项不允许为空'}]">
						<a-select style="width: 300px;" :disabled="isSee" v-model:value="modelRef.memberCardLevels" mode="tags" placeholder="请选择">
							<a-select-option v-for="item in cardList" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
						</a-select>
						<a-button style="margin-left: 10px;" type="primary" shape="circle" @click="getCardList(0)">
							<template #icon>
								<Icon icon="RedoOutlined"></Icon>
							</template>
						</a-button>
					</a-form-item>
				</div>

				<div v-if="modelRef.type === 3">
					<a-form-item label="注册时间段">
						<a-form-item-rest>
							<a-button style="margin-bottom: 10px;" type="primary" v-if="!isSee"
								@click="onAddUserTime">添加时间段</a-button>
							<a-col v-for="(item, index) in userTimeList" style="margin-bottom: 10px;">
								<a-range-picker v-model:value="item.timeValue" showTime />
								<a-button style="margin-left: 10px;" type="primary" @click="onDeleteUserTime(index)">删除</a-button>
							</a-col>
						</a-form-item-rest>
					</a-form-item>
				</div>

				<a-form-item label="有效期" name="validType" :rules="[{required: true, message: '必填项不允许为空'}]">
					<a-radio-group :disabled="isSee" v-model:value="modelRef.validType" button-style="solid">
						<a-radio-button :value="1">永久有效</a-radio-button>
						<a-radio-button :value="2">指定日期</a-radio-button>
					</a-radio-group>
				</a-form-item>

				<a-form-item v-if="modelRef.validType === 2" label="指定日期" name="time"
					:rules="[{required: true, message:'必填项不允许为空'}]">
					<a-range-picker :disabled="isSee" v-model:value="modelRef.time" />
				</a-form-item>

				<a-form-item label="适用时间段" name="timeList">
					<a-button style="margin-bottom: 10px;" type="primary" v-if="!isSee"
						@click="onAddTime">添加时间段</a-button>
					<a-col v-for="(item, index) in timeList" style="margin-bottom: 10px;">
						<a-time-range-picker v-model:value="item.timeValue" format="HH:mm:ss" />
						<a-button style="margin-left: 10px;" type="primary" @click="onDeleteTime(index)">删除</a-button>
					</a-col>
				</a-form-item>

				<a-form-item label="时间类型" name="timeType" :rules="[{required: true, message: '必填项不允许为空'}]"
					v-if="timeList.length || modelRef.validType === 2">
					<a-radio-group :disabled="isSee" v-model:value="modelRef.timeType" button-style="solid">
						<a-radio-button :value="1">放映时间</a-radio-button>
						<a-radio-button :value="2">购买时间</a-radio-button>
					</a-radio-group>
				</a-form-item>

				<a-form-item label="优先级" name="sort">
					<a-input :disabled="isSee" v-model:value="modelRef.sort" placeholder="不填默认为0"></a-input>
				</a-form-item>

				<a-form-item label="是否启用" name="isDisabled" :rules="[{ required: true, message: '必填项不允许为空' }]">
					<a-radio-group :disabled="isSee" v-model:value="modelRef.isDisabled">
						<a-radio :value="0">启用</a-radio>
						<a-radio :value="1">禁用</a-radio>
					</a-radio-group>
				</a-form-item>

				<a-form-item>
					<div style="text-align: center;">
						<a-button type="primary" v-if="!isSee" html-type="submit">提交</a-button>
						<a-button style="margin-left: 20px;" @click="onBack(false)">返回</a-button>
					</div>
				</a-form-item>
			</a-form>
		</a-spin>
	</div>
</template>

<script>
	import { Icon } from '@/components/icon/icon.js';
	import Header from '@/components/header/header.vue';
	import movie from './components/movie.vue';
	import couponRecord from '@/components/couponRecord/index.vue';
	import { getCardPolicyList } from '@/service/modules/coupon.js';
	import {
		getOrganizationList,
		getCinemaList,
		getCinemaFilmModeDetail,
		saveCinemaFilmMode,
		updateCinemaFilmMode
	} from '@/service/modules/cinema.js';
	export default {
		components: {
			Icon,
			Header,
			movie,
			couponRecord
		},
		props: {
			isEdit: {
				type: Boolean,
				default: false
			},
			isSee: {
				type: Boolean,
				default: false
			},
			id: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				loading: false,
				modelRef: {
					isDisabled: 0,
					standardCode: [],
					// buyTicketMode: 1,
					validType: 1,
					time: [],
					type: 0,
					payTypes: [],
					sort: '',
					timeType: 1, //时间类型
					couponBatchNos: [],
					memberCardLevels: []
				},
				timeList: [],
				userTimeList: [],
				organizationList: [],
				cinemaList: [],
				movieList: [],
				movieColumns: [{
						title: '唯一编码',
						dataIndex: 'standardCode'
					}, {
						title: '影片名称',
						dataIndex: 'name'
					},
					// {
					// 	title: '语言',
					// 	dataIndex: 'language',
					// 	width: 80,
					// 	align: 'center'
					// },
					{
						title: '操作',
						key: 'action'
					},
				],
				cardList: [],
				exchangeList: [],
				exchangeColumns: [{
					title: '批次号',
					dataIndex: 'batchNo'
				}, {
					title: '批次名称',
					dataIndex: 'name'
				}, {
					title: '有效期',
					key: 'time'
				}, {
					title: '是否通兑',
					key: 'isHoliday',
					width: 100
				}, {
					title: '补差金额（元）',
					dataIndex: 'diffPrice',
					width: 130
				}, {
					title: '兑换券数量',
					dataIndex: 'importCount',
					width: 130
				}, {
					title: '已绑定数量',
					dataIndex: 'bindCount',
					width: 130
				}, {
					title: '未兑换数量',
					key: 'redeemedCount',
					width: 130
				}, {
					title: '操作',
					key: 'action',
					fixed: 'right',
					width: 100
				}],
			}
		},
		created() {
			this.getOrganizationList();
			if (this.id) {
				this.getDetail();
				this.movieColumns = [{
					title: '唯一编码',
					dataIndex: 'standardCode'
				}, {
					title: '影片名称',
					dataIndex: 'name'
				}, ]
			} else {
				this.userTimeList = [{
					timeValue: undefined
				}];
				this.timeList = [{
					timeValue: undefined
				}];
			}
		},
		methods: {
			onBack(isRef) {
				this.$emit('back', isRef);
			},
			async onSubmit() {
				this.loading = true;
				let postData = JSON.parse(JSON.stringify(this.modelRef));
				if (postData.validType === 2 && postData.time) {
					postData.startTime = this.moment(postData.time[0]).startOf('day').unix();
					postData.endTime = this.moment(postData.time[1]).endOf('day').unix();
				}
				delete postData.time
				if (postData.payTypes.includes(4)) {
					postData.couponBatchNos = postData.couponBatchNos.filter(Boolean).join(",");
				} else {
					postData.couponBatchNos = "";
				}
				if (postData.payTypes.includes(5)) {
					postData.memberCardLevels = postData.memberCardLevels.filter(Boolean).join(",");
				} else {
					postData.memberCardLevels = "";
				}
				if (postData.type == 1) {
					// postData.standardCode = postData.standardCode[0];
					postData.standardCode = postData.standardCode.filter(Boolean).join(',');
					postData.payTypes = '';
				} else if (postData.type == 2) {
					postData.payTypes = postData.payTypes.filter(Boolean).join(',');
					postData.standardCode = '';
					postData.filmName = '';
				} else {
					postData.payTypes = "";
				}
				const timeList = [];
				let checkFlag = true;
				if (this.timeList.length) {
					this.timeList.forEach(item => {
						if (item.timeValue && item.timeValue.length) {
							const startTime = this.moment(item.timeValue[0]);
							const endTime = this.moment(item.timeValue[1]);
							timeList.push({
								startTime: startTime.hour() * 3600 + startTime.minute() * 60 +
									startTime.second(),
								endTime: endTime.hour() * 3600 + endTime.minute() * 60 + endTime
									.second(),
							})
						} else {
							checkFlag = false;
						}
					})
				}
				const userTimeList = [];
				if (postData.type === 3) {
					if (this.userTimeList.length) {
						this.userTimeList.forEach(item => {
							if (item.timeValue && item.timeValue.length) {
								const startTime = this.moment(item.timeValue[0]);
								const endTime = this.moment(item.timeValue[1]);
								userTimeList.push({
									startTime: this.moment(item.timeValue[0]).unix(),
									endTime: this.moment(item.timeValue[1]).unix(),
								})
							} else {
								checkFlag = false;
							}
						})
					}
				}
				if (!checkFlag) {
					this.loading = false;
					return this.$message.error('请检查时间段配置');
				} else if (timeList.length) {
					postData.timeList = JSON.stringify(timeList);
				}
				if (userTimeList.length) {
					postData.userTimeList = JSON.stringify(userTimeList);
				}
				if (postData.validType != 2 && !postData.timeList) {
					delete postData.timeType;
				}
				let ret;
				if (this.isEdit) {
					ret = await updateCinemaFilmMode(postData);
				} else {
					ret = await saveCinemaFilmMode(postData);
				}
				this.loading = false;
				if (ret.code === 200) {
					if (this.isEdit) {
						this.$message.success('编辑成功！');
					} else {
						this.$message.success('新增成功！');
					}
					this.onBack(true);
				}
			},
			async getDetail() {
				this.loading = true;
				try {
					let ret = await getCinemaFilmModeDetail({
						id: this.id
					});
					this.loading = false;
					if (ret.code === 200) {
						ret.data.standardCode = [ret.data.standardCode];
						if (ret.data.validType === 2) {
							ret.data.time = [this.moment(ret.data.startTime * 1000), this.moment(ret.data.endTime *
								1000)];
						} else {
							ret.data.time = [];
						}
						if (ret.data.payTypes) ret.data.payTypes = ret.data.payTypes.split(',').filter(Boolean).map(item => {
							return parseInt(item)
						});
						if(ret.data.couponBatchNos) {
							ret.data.couponBatchNos = ret.data.couponBatchNos.split(",").filter(Boolean).map(item => Number(item));
						} else {
							ret.data.couponBatchNos = [];
						}
						if(ret.data.memberCardLevels) {
							ret.data.memberCardLevels = ret.data.memberCardLevels.split(",").filter(Boolean).map(item => Number(item));
						} else {
							ret.data.memberCardLevels = [];
						}
						// this.movieList = [ret.data.cinemaFilm];
						this.movieList = ret.data.cinemaFilmList;
						// delete ret.data.cinemaFilm;
						delete ret.data.startTime;
						delete ret.data.endTime;
						this.getAllCinemaList(ret.data.organizationId);
						this.modelRef = ret.data;
						this.exchangeList = ret.data.voucherImportRecordList;
						this.getCardList();
						if (ret.data.timeList) {
							const timeList = JSON.parse(ret.data.timeList);
							timeList.forEach(item => {
								this.timeList.push({
									timeValue: [this.moment().startOf('day').add(item.startTime,
										'seconds'), this.moment().startOf('day').add(item
										.endTime, 'seconds')]
								})
							})
						}
						if (ret.data.userTimeList) {
							const userTimeList = JSON.parse(ret.data.userTimeList);
							userTimeList.forEach(item => {
								this.userTimeList.push({
									timeValue: [this.moment(item.startTime * 1000), this.moment(item.endTime * 1000)]
								})
							})
						}
					}
				} catch (e) {
					this.loading = false;
				}
			},
			async getOrganizationList() {
				let ret = await getOrganizationList({
					page: 1,
					pageSize: 999999
				});
				if (ret.code === 200) {
					this.organizationList = ret.data.list;
				}
			},
			async getAllCinemaList(organizationId) {
				this.cinemaAllList = [];
				this.modelRef.cinemaId = undefined;
				let ret = await getCinemaList({
					page: 1,
					pageSize: 999999,
					organizationId: organizationId ? organizationId : undefined
				})
				if (ret.code === 200) {
					this.cinemaList = ret.data.list;
				}
			},
			async getCardList() {
				if (!this.modelRef.cinemaId) {
					// this.$message.warn('请选择所属影院');
					return;
				}
				this.cardLoading = true;
				try {
					let ret = await getCardPolicyList({
						page: 1,
						pageSize: 99999,
						// organizationId: this.modelRef.organizationId,
						//线上会员卡才需要useCinemaId
						useCinemaId: this.modelRef.cinemaId,
						type: 3,
						isDisabled: 0
					});
					this.cardLoading = false;
					if (ret.code === 200) {
						this.cardList = ret.data.list;
					}
				} catch (e) {
					this.cardLoading = false;
				}
			},
			onCinemaChange() {
				this.movieList = [];
				this.modelRef.standardCode = [];
			},
			onDeleteMovie(item, index) {
				let i = this.modelRef.standardCode.indexOf(item.id);
				this.modelRef.standardCode.splice(i, 1);
				this.movieList.splice(index, 1);
			},
			onAddTime() {
				this.timeList.push({
					timeValue: ''
				});
			},
			onAddUserTime() {
				this.userTimeList.push({
					timeValue: ''
				})
			},
			onDeleteTime(index) {
				this.timeList.splice(index, 1);
			},
			onDeleteUserTime(index) {
				this.userTimeList.splice(index, 1);
			},
			onPayTypeChange(e) {
				console.log(e);
			},
			onCouponChange(type, data) {
				if (type === 1) {
					this.exchangeList = data || [];
				}
				if (type === 3) {
					this.snackList = data || [];
				}
			},
			onDelCoupon(type, index) {
				if (type === 1) {
					const item = this.exchangeList.splice(index, 1);
					this.modelRef.couponBatchNos = this.modelRef.couponBatchNos.filter(id => id != item[0].id );
				}
				if (type === 3) {
					const item = this.snackList.splice(index, 1);
					this.modelRef.snackBatchId = this.modelRef.snackBatchId.filter(id => id != item[0].id );
				}
			},
		}
	}
</script>

<style>
</style>
